import { throwIfRateLimited } from '@/services/apiErrors';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

/**
 * Update user consents (protected endpoint)
 * @param token - Cognito id token
 * @param consents - object like { terms: true, privacy: true }
 */
export const updateUserConsent = async (
  token: string,
  consents: Record<string, boolean>,
  /** 同意（agree）か確認（acknowledge）か、どの画面からか。履歴（CONSENTLOG#）に残る */
  meta?: { action: 'agree' | 'acknowledge'; source: 'consent_page' | 'policy_notice' }
): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/user/consent`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...consents, ...meta }),
  });

  if (!response.ok) {
      throwIfRateLimited(response);
    const err = await response.json().catch(() => ({ message: '同意情報の更新に失敗しました' }));
    throw new Error(err.message || '同意情報の更新に失敗しました');
  }
};

